import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Autoplay, Pagination } from "swiper/modules";

const Testimonial = () => {
  const [testimonial, setTestimonial] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_KEY + "testimonials");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responseData = await response.json();
        setTestimonial(responseData.testimonial);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <>
      <section
        className="testimonial-style-one space-y-top space-y-bottom"
        id="testimonial"
      >
        <div className="container">
          <div className="section-heading pb-5 text-center">
            <h2>TESTIMONIAL</h2>
          </div>
          <Swiper
            className="swiper testimonial-slider"
            spaceBetween={50}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            modules={[Autoplay, Pagination]}
            pagination={false}
            loop={true}
            breakpoints={{
              1200: { slidesPerView: 3 },
              990: { slidesPerView: 2 },
              640: { slidesPerView: 1 }, // Limit to one tile for mobile screens
            }}
          >
            <div className="swiper-wrapper">
              {testimonial.length > 0 ? testimonial.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="swiper-slide">
                    <div className="testimonial-card">
                      <div className="qoute-icon">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M27.8337 15.028C27.8337 13.0343 28.5152 11.3645 29.8783 10.0187C31.2414 8.6729 32.9452 8 34.9899 8C36.9371 8 38.5923 8.77259 39.9554 10.3178C41.3185 11.8629 42 13.8069 42 16.1495C42 17.8442 41.6349 19.7134 40.9047 21.757C40.1258 23.8006 39.1278 25.8692 37.9108 27.9626C36.645 30.0561 35.2333 32.1246 33.6755 34.1682C32.069 36.2617 30.4625 38.2056 28.856 40L26.8844 38.3551C29.075 35.7134 30.9006 33.0467 32.3611 30.3551C33.8215 27.6636 34.6978 25.0218 34.9899 22.4299C33.0426 22.2804 31.3631 21.5327 29.9513 20.1869C28.5396 18.8411 27.8337 17.1215 27.8337 15.028ZM6.87626 15.028C6.87627 13.0343 7.55781 11.3645 8.92089 10.0187C10.284 8.6729 11.9878 8 14.0325 8C15.9797 8 17.6349 8.77259 18.998 10.3178C20.3611 11.8629 21.0426 13.8069 21.0426 16.1495C21.0426 17.8442 20.6775 19.7134 19.9473 21.757C19.1684 23.8006 18.1704 25.8692 16.9533 27.9626C15.6876 30.0561 14.2759 32.1246 12.7181 34.1682C11.1116 36.2617 9.50507 38.2056 7.89857 40L6 38.3551C8.19067 35.7134 10.0162 33.0467 11.4767 30.3551C12.8884 27.6635 13.7404 25.0218 14.0325 22.4299C12.0852 22.2804 10.4057 21.5327 8.99391 20.1869C7.58215 18.8411 6.87626 17.1215 6.87626 15.028Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <h5 className="testimonial-disc">
                        {testimonial.experience}
                      </h5>
                      <p className="reviewer">-{testimonial.author}, {testimonial.date}</p>
                    </div>
                  </div>
                </SwiperSlide>
              )) : <h5 className="d-flex justify-content-center w-100">“I'd love to hear about your experience working with me.”</h5>}
            </div>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
